import { useEffect } from "react";
import { exportGridImages } from "../utils/exportGridImages";

export function useGeneratePreviews({
  canvasRef,
  img,
  scale,
  offset,
  grid,
  setPieces,
}) {
  useEffect(() => {
    if (!img) {
      setPieces([]);
      return undefined;
    }

    const t = setTimeout(() => {
      try {
        const previewPieces = exportGridImages({
          canvas: canvasRef.current,
          img,
          grid,
          scale,
          offset,
          pieceSize: 140,
          quality: 0.72,
        });

        setPieces(previewPieces);
      } catch (error) {
        setPieces([]);
      }
    }, 200);

    return () => clearTimeout(t);
  }, [canvasRef, img, scale, offset, grid, setPieces]);
}
